import { v4 as uuidv4 } from 'uuid';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function FooterMobile() {
	return {
		componentName: 'FooterMobile',
		componentId: uuidv4(),
		componentGroup: 'FooterMobile',
		props: {
			mzTitle: 'MZ | Footer - Mobile',
		},
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'footer-mobile-2',
				},
				[
					FlexLayoutCol(
						{
							blockClass: 'footer-mobile-2-logo',
						},
						[
							Image({
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046479085-JdNwrJt.png',
							}),
						],
					),

					FlexLayoutCol({}, [
						VisibilityLayout({ mzTitle: 'MZ | Menu A Loja (On/Off)' }, [
							DisclosureLayout({}, [
								DisclosureTrigger(
									{
										blockClass: 'footer-2-disclosure-trigger',
									},
									[
										RichText({
											text: 'A [nome loja]',
											blockClass: 'footer-mobile-2-title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
									],
								),
								DisclosureContent({}, [
									Menu({
										blockClass: 'footer-mobile-2-content__menu',
										orientation: 'vertical',
										items: [
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Quem Somos',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Como comprar no nosso site',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Formas de Compra e Entrega',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Política de Troca e Devolução',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Política de Privacidade LGPD',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Fale Conosco',
												},
											}).props,
										],
									}),
								]),
							]),
						]),
						VisibilityLayout({ mzTitle: 'MZ | Menu Sua Conta (On/Off)' }, [
							DisclosureLayout({}, [
								DisclosureTrigger(
									{
										blockClass: 'footer-2-disclosure-trigger',
									},
									[
										RichText({
											text: 'Sua Conta',
											blockClass: 'footer-mobile-2-title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
									],
								),
								DisclosureContent({}, [
									Menu({
										blockClass: 'footer-mobile-2-content__menu',
										orientation: 'vertical',
										items: [
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/account',
													text: 'Minha Conta',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/account#/orders',
													text: 'Meus Pedidos',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Meus Favoritos',
												},
											}).props,
											MenuItem({
												blockClass: 'footer-mobile-2-content__menu-item',
												itemProps: {
													href: '/#',
													text: 'Notificação por email',
												},
											}).props,
										],
									}),
								]),
							]),
						]),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Atendimento (On/Off)' }, [
						FlexLayoutCol(
							{
								blockClass: 'footer-mobile-2-content',
							},
							[
								RichText({
									text: '**Atendimento**',
									blockClass: 'footer-mobile-2-title',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								RichText({
									text: 'De segunda a sexta, das 9h as 18h.',
									blockClass: 'footer-mobile-2-content__atendimento',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								RichText({
									text: 'Telefones: **(00) 0000-0000 / (00) 0 0000-0000**',
									blockClass: 'footer-mobile-2-content__atendimento',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								RichText({
									text: 'E-mail: [contato@nomeloja.com.br](mailto:contato@nomeloja.com.br)',
									blockClass: 'footer-mobile-2-content__atendimento',
									textAlignment: 'left',
									textPosition: 'left',
								}),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Redes Sociais (On/Off)' }, [
						FlexLayoutCol(
							{
								blockClass: 'footer-mobile-2-content',
							},
							[
								RichText({
									text: '**Nossas Redes Sociais**',
									textAlignment: 'left',
									textPosition: 'left',
									blockClass: 'footer-mobile-2-title',
								}),
								FlexLayoutRow(
									{
										horizontalAlign: 'left',
										colSizing: 'auto',
										blockClass: 'footer-mobile-2-social-icons',
										preserveLayoutOnMobile: true,
									},
									[
										StoreImageList(
											{
												height: 12,
												images: [
													{
														description: 'Facebook',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046717711-212365083-5b98cc81-5847-402a-9ab8-290df2ccb242.png',
														link: {
															url: 'https://www.facebook.com/',
															newTab: true,
														},
													},
													{
														description: 'Instagram',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046730547-212365091-d67ff0ac-e491-4e2b-bee6-087f6eb20031.png',
														link: {
															url: 'https://www.instagram.com/',
															newTab: true,
														},
													},
													{
														description: 'Twitter',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046743459-212365094-c5cd4039-4f34-42e6-9115-e6c034297413.png',
														link: {
															url: 'https://twitter.com/',
															newTab: true,
														},
													},
												],
											},
											[
												ListContextRenderer({
													blockClass: 'footer-mobile-2-social-icons__list',
													listElement: 'ul',
													itemElement: 'li',
												}),
											],
										),
									],
								),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Formas de Pagamento (On/Off)' }, [
						FlexLayoutCol(
							{
								blockClass: 'footer-mobile-2-content',
							},
							[
								RichText({
									text: '**Formas de pagamento e bandeiras aceitas**',
									blockClass: 'footer-mobile-2-title',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								FlexLayoutRow(
									{
										colSizing: 'auto',
										horizontalAlign: 'left',
										blockClass: 'footer-mobile-2-payment-logo',
										preserveLayoutOnMobile: true,
									},
									[
										StoreImageList(
											{
												height: 36,
												images: [
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-mastercard.png',
														alt: 'MasterCard',
														title: 'MasterCard',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-visa.png',
														alt: 'Visa',
														title: 'Visa',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hipercard.png',
														alt: 'Hipercard',
														title: 'Hipercard',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hiper.png',
														alt: 'Hiper',
														title: 'Hiper',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-dinersclub.png',
														alt: 'Diners Club',
														title: 'Diners Club',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-jcb.png',
														alt: 'JCB',
														title: 'JCB',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-discover.png',
														alt: 'Discover',
														title: 'Discover',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-elo.png',
														alt: 'Elo',
														title: 'Elo',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-boleto.png',
														alt: 'Boleto',
														title: 'Boleto',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-pix.png',
														alt: 'Pix',
														title: 'Pix',
													},
												],
											},
											[
												ListContextRenderer({
													blockClass: 'footer-mobile-2-payment__list',
													listElement: 'ul',
													itemElement: 'li',
												}),
											],
										),
									],
								),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Selos de Segurança (On/Off)' }, [
						FlexLayoutCol(
							{
								blockClass: 'footer-mobile-2-content',
							},
							[
								RichText({
									text: '**Selos de segurança**',
									blockClass: 'footer-mobile-2-title',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								FlexLayoutRow(
									{
										blockClass: 'footer-mobile-2--high',
										fullWidth: true,
										preserveLayoutOnMobile: true,
									},
									[
										StoreImageList(
											{
												height: 55,
												images: [
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318216942-eureciclo.png',
														alt: 'Eureciclo',
														title: 'SeloEu Reciclo',
														link: {
															url: '',
														},
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318175602-ebit.png',
														alt: 'Ebit',
														title: 'Selo Ebit',
														link: {
															url: '',
														},
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318302329-lets-encrypt.png',
														alt: 'Let`s Encript',
														title: 'Selo Let`s Encript',
														link: {
															url: '',
														},
													},
												],
											},
											[
												ListContextRenderer({
													blockClass: 'footer-mobile-2-security__flags',
													listElement: 'ul',
													itemElement: 'li',
												}),
											],
										),
									],
								),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Texto SEO (On/Off)' }, [
						FlexLayoutCol({}, [
							RichText({
								textAlignment: 'LEFT',
								textPosition: 'CENTER',
								text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Malesuada quis sit massa rutrum vestibulum. Consequat neque, sit mattis rutrum ullamcorper in lectus adipiscing. Nisl, natoque mauris lectus cursus. Felis tristique quis faucibus mauris et id massa nulla. Condimentum...',
								blockClass: 'footer-mobile-2-description__text',
							}),
							RichText({
								textAlignment: 'CENTER',
								textPosition: 'CENTER',
								text: '[Loja](/about)',
								blockClass: 'footer-mobile-2-description__link',
							}),
						]),
					]),
					FlexLayoutCol(
						{
							blockClass: 'footer-mobile-2-legal__description',
						},
						[
							RichText({
								text: '[NOME EMPRESA] LTDA - CNPJ: 00.000.000/0001-00 [RUA OU AVENIDA], 000 - [BAIRRO], [CIDADE] - [UF], CEP 00000-000',
								blockClass: 'footer-mobile-2-legal-text',
							}),
						],
					),
					FlexLayoutCol(
						{
							blockClass: 'footer-mobile-2-powered-by',
						},
						[
							FlexLayoutRow(
								{
									preserveLayoutOnMobile: true,
									colSizing: 'auto',
									horizontalAlign: 'center',
								},
								[
									FlexLayoutCol({}, [
										RichText({
											text: 'Powered by',
											blockClass: 'footer-mobile-2-powered-by__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-logo-checkout-vtex.png',
											title: 'VTEX',
											link: {
												url: 'https://vtex.com/',
												openNewTab: true,
											},
											blockClass: 'footer-mobile-2',
										}),
									]),
									FlexLayoutCol({}, [
										RichText({
											text: 'Desenvolvido',
											blockClass: 'footer-mobile-2-powered-by__title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166276-logo-checkout-maeztra.png',
											title: 'Maeztra',
											link: {
												url: 'https://maeztra.com/',
												openNewTab: true,
											},
											blockClass: 'footer-mobile-2',
										}),
									]),
								],
							),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--footer-mobile-2-background-color', name: 'Background' },
			{ from: '--brand-color-primary-pure', to: '--footer-mobile-2-highlight-color', name: 'Highlight' },
			{ from: '--text-color-1', to: '--footer-mobile-2-text-color', name: 'Text' },
			{ from: '--text-color-1', to: '--footer-mobile-2-legal-color', name: 'Legal Text' },
			{ from: '--brand-color-secondary-pure', to: '--footer-mobile-2-social-color', name: 'Social Media Color' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-sm', to: '--footer-mobile-2-highlight-size', name: 'Highlight Size' },
			{ from: '--font-size-sm', to: '--footer-mobile-2-menu-size', name: 'Menu Text size' },
			{ from: '--font-size-sm', to: '--footer-mobile-2-description-size', name: 'Description Text size' },
			//legal text
			{ from: '--font-size-xs', to: '--footer-mobile-2-legal-size', name: 'Legal Text size' },
		],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-nano', to: '--footer-m-2-social-spacing', name: 'Social Media padding' }],
	},
	{
		type: 'borderRadius',
		list: [{ from: 0, to: '--footer-2-m-social-radius', name: 'Social Media Border Radius' }],
	},
	//typography
	{
		type: 'typography',
		list: [
			//highlight
			{ from: '--main-font', to: '--footer-mobile-2-highlight-ff', name: 'Highlight' },
			//menu footer
			{ from: '--main-font', to: '--footer-mobile-2-menu-ff', name: 'Menu' },
			//SEO text
			{ from: '--main-font', to: '--footer-mobile-2-seo-ff', name: 'Description' },
			//legal text
			{ from: '--main-font', to: '--footer-mobile-2-legal-ff', name: 'Legal Text' },
		],
	},
];
